/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.1159 22.6359 2.212 13.7938C.786 12.3777 0 10.4946 0 8.4926c0-2.003.786-3.8847 2.212-5.3008C4.8763.5474 9.052.2957 12.0026 2.438c2.9514-2.1413 7.1258-1.8925 9.7906.7541 2.9424 2.922 2.9424 7.6779 0 10.6001l-8.9042 8.8436a1.2556 1.2556 0 0 1-.8868.3641 1.2572 1.2572 0 0 1-.8863-.3641Zm2.84-17.2248L16.4352 9.75H19a.75.75 0 0 1 0 1.5h-3.4352l-1.5207-2.6612-3.5 7L8.0648 11.25H5a.75.75 0 0 1 0-1.5h3.9352l1.5207 2.6611 3.5-7Z"
    clipRule="evenodd"
  />,
  'MenuHelthChecksFilled'
);
